export default __webpack_public_path__ + "static/media/Vida-segura.b3e19203.svg";